import { OpType } from '../graph/types';

export interface ThemeColors {
  background: string;
  nodeFill: string;
  nodeStroke: string;
  nodeText: string;
  nodeSublabel: string;
  edgeStroke: string;
  edgeText: string;
  tooltipBg: string;
  tooltipText: string;
  opColors: Record<OpType, string>;
}

function readCssVar(name: string, fallback: string): string {
  if (typeof document === 'undefined') return fallback;
  const value = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return value || fallback;
}

export function getThemeColors(): ThemeColors {
  return {
    background: readCssVar('--viz-bg', '#ffffff'),
    nodeFill: readCssVar('--viz-node-fill', '#f8fafc'),
    nodeStroke: readCssVar('--viz-node-stroke', '#94a3b8'),
    nodeText: readCssVar('--viz-node-text', '#1e293b'),
    nodeSublabel: readCssVar('--viz-node-sublabel', '#64748b'),
    edgeStroke: readCssVar('--viz-edge', '#94a3b8'),
    edgeText: readCssVar('--viz-edge-text', '#475569'),
    tooltipBg: readCssVar('--viz-tooltip-bg', '#0f172a'),
    tooltipText: readCssVar('--viz-tooltip-text', '#f8fafc'),
    opColors: {
      input: readCssVar('--viz-op-input', '#3b82f6'),
      output: readCssVar('--viz-op-output', '#ef4444'),
      linear: readCssVar('--viz-op-linear', '#8b5cf6'),
      matmul: readCssVar('--viz-op-matmul', '#f59e0b'),
      softmax: readCssVar('--viz-op-softmax', '#10b981'),
      'cross-entropy': readCssVar('--viz-op-cross-entropy', '#f97316'),
      scale: readCssVar('--viz-op-scale', '#06b6d4'),
      reshape: readCssVar('--viz-op-reshape', '#6366f1'),
      transpose: readCssVar('--viz-op-transpose', '#ec4899'),
      permute: readCssVar('--viz-op-permute', '#ec4899'),
      add: readCssVar('--viz-op-add', '#14b8a6'),
      mul: readCssVar('--viz-op-mul', '#14b8a6'),
      concat: readCssVar('--viz-op-concat', '#f97316'),
      norm: readCssVar('--viz-op-norm', '#84cc16'),
      activation: readCssVar('--viz-op-activation', '#d946ef'),
      embedding: readCssVar('--viz-op-embedding', '#3b82f6'),
      router: readCssVar('--viz-op-router', '#f43f5e'),
      gate: readCssVar('--viz-op-gate', '#f59e0b'),
      expert: readCssVar('--viz-op-expert', '#8b5cf6'),
      'selective-scan': readCssVar('--viz-op-selective-scan', '#10b981'),
      'state-space': readCssVar('--viz-op-state-space', '#06b6d4'),
      cache: readCssVar('--viz-op-cache', '#f59e0b'),
      quantize: readCssVar('--viz-op-quantize', '#ec4899'),
      dropout: readCssVar('--viz-op-dropout', '#64748b'),
      mask: readCssVar('--viz-op-mask', '#475569'),
      cast: readCssVar('--viz-op-cast', '#06b6d4'),
      loss: readCssVar('--viz-op-loss', '#f97316'),
      metric: readCssVar('--viz-op-metric', '#84cc16'),
      allreduce: readCssVar('--viz-op-allreduce', '#f43f5e'),
      allgather: readCssVar('--viz-op-allgather', '#f97316'),
      'reduce-scatter': readCssVar('--viz-op-reduce-scatter', '#f59e0b'),
      all2all: readCssVar('--viz-op-all2all', '#ec4899'),
      p2p: readCssVar('--viz-op-p2p', '#8b5cf6'),
      split: readCssVar('--viz-op-split', '#6366f1'),
      replicate: readCssVar('--viz-op-replicate', '#3b82f6'),
      conv: readCssVar('--viz-op-conv', '#06b6d4'),
      pool: readCssVar('--viz-op-pool', '#84cc16'),
      fusion: readCssVar('--viz-op-fusion', '#d946ef')
    }
  };
}
